export const environment = {
  production: false,
  api_base_url: 'https://hub-ac-management-api.prd-51.aws.agilent.com',
  registration_api_base_url: 'https://hub-ac-registration-api.prd-51.aws.agilent.com',
  iot_base_url: 'https://a3cb4mwmdz2oep-ats.iot.us-east-1.amazonaws.com',
  authentication_mode: 'cognito',
  cognito_client_id: '4go5l34u5a1ananimtoitkmho7',
  cognito_app_web_domain: 'hub-ac-login.cid.agilent.com',
  cognito_token_scopes_array: [
    'email',
    'openid',
    'profile',
    'aws.cognito.signin.user.admin'
  ],
  cognito_redirect_uri_sign_in: 'https://hub.cid.agilent.com/login/cognito-callback/',
  cognito_redirect_uri_sign_out: 'https://hub.cid.agilent.com/',
  cognito_user_pool_id: 'us-east-1_i9JpPcr8g',
  cognito_user_pool_arn: 'arn:aws:cognito-idp:us-east-1:768955942055:userpool/us-east-1_i9JpPcr8g',
  oktaConfig: {
    clientId: '0oayddj03wD3CPNJ80h7',
    redirectUri: 'https://tjcdev-ac-portal.prd-27.aws.agilent.com/login/callback',
    issuer: 'https://dev-login.agilent.com/oauth2/default',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    agilentAppId: 'acpl',
    agilentBaseUrl: 'https://dev-register.agilent.com'
  },
  is_auth_disabled: false,
  release_date: '2026-10-15T01:45:59.151255',
  data_tunneling_iot_endpoint: 'https://data.tunneling.iot.us-east-1.amazonaws.com',
};
